export async function getDeviceFingerprint(): Promise<string> {
  if (typeof window === 'undefined') return 'ssr';
  
  const getCanvasFingerprint = (): string => {
    try {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      if (!ctx) return '';
      ctx.textBaseline = 'top';
      ctx.font = "14px 'Arial'";
      ctx.textBaseline = 'alphabetic';
      ctx.fillStyle = '#f60';
      ctx.fillRect(125, 1, 62, 20);
      ctx.fillStyle = '#069';
      ctx.fillText('vfx-edtech-fingerprint, Hello! 😃', 2, 15);
      ctx.fillStyle = 'rgba(102, 204, 0, 0.7)';
      ctx.fillText('vfx-edtech-fingerprint, Hello! 😃', 4, 17);
      return canvas.toDataURL();
    } catch {
      return '';
    }
  };

  const components = [
    navigator.userAgent,
    navigator.language,
    screen.colorDepth,
    `${screen.width}x${screen.height}`,
    `${screen.availWidth}x${screen.availHeight}`,
    new Date().getTimezoneOffset(),
    !!window.sessionStorage,
    !!window.localStorage,
    !!window.indexedDB,
    navigator.hardwareConcurrency || '',
    (navigator as any).deviceMemory || '',
    screen.orientation ? screen.orientation.type : '',
    getCanvasFingerprint()
  ];

  const dataString = components.join('|');
  
  try {
    const msgBuffer = new TextEncoder().encode(dataString);
    const hashBuffer = await crypto.subtle.digest('SHA-256', msgBuffer);
    const hashArray = Array.from(new Uint8Array(hashBuffer));
    const hashHex = hashArray.map(b => b.toString(16).padStart(2, '0')).join('');
    return hashHex;
  } catch {
    // Fallback simple hash if SubtleCrypto fails
    let hash = 0;
    for (let i = 0; i < dataString.length; i++) {
      const char = dataString.charCodeAt(i);
      hash = ((hash << 5) - hash) + char;
      hash = hash & hash; // Convert to 32bit integer
    }
    return 'fb_' + Math.abs(hash).toString(16);
  }
}
